import { fork, call, put, take, select } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';


/**
* Get port
* */
export function* getPort(data) {
    const response = yield call(api.getPort, data);

    // const normalizeData = normalize(response.data, portsSchema);
    // console.log('normalizeData', normalizeData);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_PORT.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_PORT.FAILURE,
        errors: response.errors,
    });
}

/**
 * Watcher get ports
 * */
export function* watchGetPort() {
    while (true) {
        const { data } = yield take(actionTypes.GET_PORT.REQUEST);
        yield call(getPort, data);
    }
}

/**
 * Get ports
 * */
export function* getPorts(pagination) {
    const response = yield call(api.getPorts, pagination);

    if (response.data && !(response.errors && response.errors.length)) {
        yield put({
            type: actionTypes.GET_PORTS.SUCCESS,
            data: response,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_PORTS.FAILURE,
        errors: response.errors,
    });
}

/**
 * Watcher get ports
 * */
export function* watchGetPorts() {
    while (true) {
        const { pagination } = yield take(actionTypes.GET_PORTS.REQUEST);
        yield call(getPorts, pagination);
    }
}

/**
 * Get all ports
 * */
export function* getAllPorts() {
    const response = yield call(api.getAllPorts);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_ALL_PORTS.SUCCESS,
            data: response.data,
        });

        return response;
    }

    yield put({
        type: actionTypes.GET_ALL_PORTS.FAILURE,
        errors: response.errors,
    });
}

/**
 * Watcher get all ports
 * */
export function* watchGetAllPorts() {
    while (true) {
        yield take(actionTypes.GET_ALL_PORTS.REQUEST);
        yield fork(getAllPorts);
    }
}

/**
 * Update port
 * */
export function* updatePort(data) {
    const values = { ...data };

    values.country = values.country._id;

    const response = yield call(api.updatePort, values);

    if (response.status === 200) {
        yield put({
            type: actionTypes.UPDATE_PORT.SUCCESS,
            data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Port updated',
                level: 'success',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.UPDATE_PORT.FAILURE,
        data,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: Math.random(),
            autoDismiss: 10,
        },
    });

    return response;
}

/**
 * Watcher update port
 * */
export function* watchUpdatePort() {
    while (true) {
        const { data } = yield take(actionTypes.UPDATE_PORT.REQUEST);
        yield fork(updatePort, data);
    }
}


/**
 * Create new port
 * */
export function* addNewPort(data) {
    const response = yield call(api.addNewPort, data);

    if (response.status === 200) {
        yield put({
            type: actionTypes.ADD_NEW_PORT.SUCCESS,
            data: response.data,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: 'Success created',
                level: 'success',
                _id: Math.random(),
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.ADD_NEW_PORT.FAILURE,
        data: response.data,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: Math.random(),
            autoDismiss: 2,
        },
    });

    return response;
}

/**
 * Watcher update port
 * */
export function* watchAddNewPort() {
    while (true) {
        const { data } = yield take(actionTypes.ADD_NEW_PORT.REQUEST);
        yield fork(addNewPort, data);
    }
}

/**
 * Update port alternative names
 * */
export function* updatePortAlt(item) {
    const response = yield call(api.updatePortAlt, item);

    if (response.status === 200) {
        yield put({
            type: actionTypes.UPDATE_PORT_ALT.SUCCESS,
            item: response.item,
        });

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Success',
                message: `${response.item.name} updated`,
                level: 'success',
                _id: response.data._id,
                autoDismiss: 2,
            },
        });

        return response;
    }

    yield put({
        type: actionTypes.UPDATE_PORT_ALT.FAILURE,
        item: response.item,
        errors: response.errors,
    });

    yield put({
        type: actionTypes.ADD_NOTIFICATION,
        notification: {
            title: 'Error',
            message: response.errors[0].messages[0],
            level: 'error',
            _id: response.item._id,
            autoDismiss: 2,
        },
    });
}

/**
 * Watcher update port
 * */
export function* watchUpdatePortAlt() {
    while (true) {
        const { item } = yield take(actionTypes.UPDATE_PORT_ALT.REQUEST);
        yield fork(updatePortAlt, item);
    }
}

export default [watchGetPort, watchGetAllPorts, watchGetPorts, watchUpdatePortAlt, watchUpdatePort, watchAddNewPort];



// WEBPACK FOOTER //
// ./app/sagas/regions/ports.js